module.exports = __webpack_public_path__ + "static/media/arrowLeftMobile.66acda1f.svg";